import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import config from "../../config";
import images from "../images";
/**
 * Use Brand Hook Attributes Hook
 * 1. Use the brand logo for the header
 * 2. Use support , privacy , help , forgot password from brand
 * 3. If not present use the default  checkventory
 * 4. Check for the config
 */
export default () => {
    /** Store image and all the  themes from localstorage */
    const { auth, appSettings, organisation, typesList } = useSelector(
        (state) => state
    );

    const { uVerifiLogoDark, uVerifiLogoLight, lightLogo, darkLogo } = images;
    const { privacyUrl, supportUrl, baseUrl, currentEnvUrl } = config.api;
    const { themeName } = appSettings;

    const cvOrgConfig = localStorage.getItem("cvOrgConfig");

    const { name } = organisation;
    const { account } = auth;
    const supportParam = `?name=${name}&email=${account ? account.email : " "}`;

    /** Check the current env */
    const isCheckVentory = useMemo(() => {
        if (baseUrl.includes("checkventory")) return true;
        else return false;
    }, [config]);

    const preloadBranding = useMemo(() => {
        const orgConfig = cvOrgConfig ? JSON.parse(cvOrgConfig) : null;
        if (!orgConfig) {
            return false; /** If no theme is present load orginal theme */
        } else {
            return true;
        }
    }, [config, cvOrgConfig]);

    const getBrandingData = (currentBrand) => {
        //If org has themes  and logos

        let logo = "";

        const brand = {
            headerLogo: currentBrand.headerLogo,
            loginLogo: currentBrand.loginLogo,
            name: currentBrand.name,
            supportUrl: isCheckVentory
                ? `${currentEnvUrl}${supportUrl}${supportParam}`
                : currentBrand.supportUrl,
            privacyPolicy:
                isCheckVentory || !currentBrand.privacyUrl
                    ? `${currentEnvUrl}${privacyUrl}`
                    : currentBrand.privacyUrl,
            themes:
                Object.keys(currentBrand.themes).length > 0
                    ? currentBrand.themes
                    : false,
        };

        const selectedTheme = localStorage.getItem("cvSelectedTheme");

        // Logo decession based on the themes
        if (selectedTheme) {
            if (selectedTheme === "original") {
                logo = currentBrand.lightLogo
                    ? currentBrand.lightLogo
                    : currentBrand.darkLogo;
                // No brand logo display checkventory logo
                logo = logo ? logo : lightLogo;
            } else if (selectedTheme === "neutral") {
                logo = currentBrand.darkLogo
                    ? currentBrand.darkLogo
                    : currentBrand.lightLogo;
                // No brand logo display checkventory logo
                logo = logo ? logo : darkLogo;
            } else if (selectedTheme === "org") {
                if (currentBrand.lightLogo)
                    logo = isCheckVentory
                        ? currentBrand.lightLogo
                        : uVerifiLogoLight;
                else if (currentBrand.darkLogo)
                    logo = isCheckVentory
                        ? currentBrand.darkLogo
                        : uVerifiLogoDark;
                //Fail safe if theme is present and no logo is present
                else logo = isCheckVentory ? lightLogo : uVerifiLogoLight; // This will be neutral theme logo
            }
        } else {
            //If org has no themes and logo. Get logo based on theme
            if (currentBrand.themes !== "") {
                logo = currentBrand.lightLogo
                    ? currentBrand.lightLogo
                    : currentBrand.darkLogo;
                localStorage.setItem("cvSelectedTheme", "org");
            } else {
                logo = isCheckVentory ? lightLogo : uVerifiLogoDark;
                localStorage.setItem("cvSelectedTheme", "original");
            }
        }
        brand.headerLogo = logo;

        /** Login logo decision
         * 1. Check for the currentBrand logo
         * 2. If there are no logo go for the brand logo
         * 3. Else go gor the default logo
         * 4. for default check if its CV or UV
         */

        brand.loginLogo = currentBrand.darkLogo
            ? currentBrand.darkLogo
            : currentBrand.lightLogo;
        brand.loginLogo = brand.loginLogo
            ? brand.loginLogo
            : currentBrand.loginLogo;

        const defaultLogo = isCheckVentory ? darkLogo : uVerifiLogoDark;
        brand.loginLogo = brand.loginLogo ? brand.loginLogo : defaultLogo;

        return brand;
    };

    const next = useMemo(() => {
        /** Set default values */
        let branding = {
            name: isCheckVentory ? "checkventory" : "uverifi",
            headerLogo: isCheckVentory ? lightLogo : uVerifiLogoLight,
            loginLogo: isCheckVentory ? darkLogo : uVerifiLogoDark,
            logoPath: "",
            needHelp: "",
            forgotPassword: "",
            supportUrl: isCheckVentory
                ? `${currentEnvUrl}${supportUrl}${supportParam}`
                : `${supportUrl}`,
            privacyPolicy: `${currentEnvUrl}${privacyUrl}`,
            themes: false,
        };

        if (preloadBranding) {
            const brand = JSON.parse(cvOrgConfig);
            return getBrandingData(brand);
        } else {
            return getBrandingData(branding);
        }
    }, [preloadBranding, themeName, organisation]);

    return next;
};
